<template>
  <div class="ls-onboarding-bush-count-view">
    <BLoading :active.sync="properties.loadingStatus.isLoading" />
    <div v-if="!properties.loadingStatus.isLoading" class="ls-onboarding-bush-count-view--main">
      <h1>Shrubs and Hedges</h1>
      <p>at {{ adddressString }}</p>
      <p class="ls-onboarding-bush-count-view--question">
        How many shrubs and hedges do you have in your yard?
      </p>
      <div class="ls-onboarding-bush-count-view--shrubs-wrapper">
        <div class="ls-onboarding-bush-count-view--shrub-and-select">
          <ShrubAndHedge size="sm" />
          <LsSelect
            v-model="bushes_0ft_5ft_count"
            test-id="bushes_0ft_5ft_count"
            class="ls-onboarding-bush-count-view--select"
            :options="options"
            name="bushes_0ft_5ft_count"
            track-id="onboarding_bush_count_view-bushes_0ft_5ft_count"
            :disabled="no_bushes"
            :validation="{ required: !no_bushes, numeric: true }"
          />
        </div>
        <div class="ls-onboarding-bush-count-view--shrub-and-select">
          <ShrubAndHedge size="md" />
          <LsSelect
            v-model="bushes_5ft_10ft_count"
            class="ls-onboarding-bush-count-view--select"
            :options="options"
            name="bushes_5ft_10ft_count"
            track-id="onboarding_bush_count_view-bushes_5ft_10ft_count"
            :disabled="no_bushes"
            :validation="{ required: !no_bushes, numeric: true }"
          />
        </div>
        <div class="ls-onboarding-bush-count-view--shrub-and-select">
          <ShrubAndHedge size="lg" />
          <LsSelect
            v-model="bushes_over_10ft_count"
            class="ls-onboarding-bush-count-view--select"
            :options="options"
            name="bushes_over_10ft_count"
            track-id="onboarding_bush_count_view-bushes_over_10ft_count"
            :disabled="no_bushes"
            :validation="{ required: !no_bushes, numeric: true }"
          />
        </div>
      </div>
      <div class="ls-onboarding-bush-count-view--checkbox">
        <BCheckbox
          v-model="no_bushes"
          name="no_bushes"
          :native-value="no_bushes"
          test-id="checkbox"
          type="is-primary-invert"
          @input="onCheck"
          >I don't have any bushes</BCheckbox
        >
      </div>

      <LsButton
        track-id="onboarding_bush_count_view-save_and_continue"
        text="submit & continue"
        class="onboarding_bush_count_view--button"
        test-id="button"
        :loading="properties.loadingStatus.isUpdating"
        @click="updateProperty"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import {
  AUTH__PROCESSING_ORDER,
  PROPERTIES__UPDATE_PROPERTY_INFO,
  PROPERTIES__PROPERTIES_IN_ARRAY,
  PROPERTIES__GET_PROPERTIES_AND_SCHEDULES,
} from '@/store/types';
import _ from 'lodash';
import { LsSelect, LsButton } from '@/components/common';
import { lsValidationService } from 'ls-vue-common';
import ShrubAndHedge from './components/ShrubAndHedge.vue';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'OnboardingBushCountView',
  $_veeValidate: {
    validator: 'new',
  },
  components: { ShrubAndHedge, LsSelect, LsButton },
  mixins: [themedComponentMixin],
  data() {
    return {
      bushes_0ft_5ft_count: null,
      bushes_5ft_10ft_count: null,
      bushes_over_10ft_count: null,
      no_bushes: false,
    };
  },
  computed: {
    ...mapState(['properties', 'featureFlags']),
    ...mapGetters([AUTH__PROCESSING_ORDER, PROPERTIES__PROPERTIES_IN_ARRAY]),
    options() {
      return _.map(_.range(31), (num) => {
        return { label: _.toString(num), value: num };
      });
    },
    adddressString() {
      const { address } = this[AUTH__PROCESSING_ORDER];
      return `${address.street}, ${address.city}, ${address.state} ${address.zip}`;
    },
    propertyId() {
      return this[PROPERTIES__PROPERTIES_IN_ARRAY][0].property_id;
    },
  },
  async created() {
    await this[PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]();
  },
  methods: {
    ...mapActions([PROPERTIES__UPDATE_PROPERTY_INFO, PROPERTIES__GET_PROPERTIES_AND_SCHEDULES]),
    onCheck() {
      if (this.no_bushes) {
        this.$validator.reset();
        this.bushes_0ft_5ft_count = null;
        this.bushes_5ft_10ft_count = null;
        this.bushes_over_10ft_count = null;
      }
    },
    onSuccess() {
      const name = 'onboardingWelcomeShare';
      this.$router.replace({ name });
    },
    async updateProperty() {
      const valid = await this.$validator.validateAll();
      if (!valid && !this.no_bushes) {
        return lsValidationService.scrollToInvalid();
      }

      await this[PROPERTIES__UPDATE_PROPERTY_INFO]({
        property_id: this.propertyId,
        info: {
          bushes_0ft_5ft_count: this.bushes_0ft_5ft_count || 0,
          bushes_5ft_10ft_count: this.bushes_5ft_10ft_count || 0,
          bushes_over_10ft_count: this.bushes_over_10ft_count || 0,
        },
        onSuccess: this.onSuccess,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.ls-onboarding-bush-count-view {
  display: flex;
  justify-content: center;
  align-items: center;
}

.ls-onboarding-bush-count-view--main {
  text-align: center;
  width: 470px;
  @media (max-width: $mobile-max-width) {
    width: 320px;
  }
}

.ls-onboarding-bush-count-view--question {
  font-weight: bold;
  padding: 40px 0 20px 0;
}

.ls-onboarding-bush-count-view--shrubs-wrapper {
  display: flex;
  justify-content: space-between;
}

.ls-onboarding-bush-count-view--shrub-and-select {
  width: 150px;
  @media (max-width: $mobile-max-width) {
    width: 100px;
  }
}

.ls-onboarding-bush-count-view--select {
  margin-top: 5px;
}

.ls-onboarding-bush-count-view--checkbox {
  padding: 20px 0 40px 0;
  display: flex;
}
</style>
